import { UserStatus } from '../enums';

export const USER_STATUS_CHIP_COLORS: Record<string, string> = {
  [UserStatus.PENDING]: 'bg-yellow-100 text-yellow-800',
  [UserStatus.ACTIVE]: 'bg-green-100 text-green-800',
  [UserStatus.INACTIVE]: 'bg-red-100 text-red-800',
  [UserStatus.DELETED]: 'bg-gray-100 text-gray-800',
};
